<template>
    <div class="F1iS">
        <h1>F1在学校是什么样的比赛?</h1>
        
        <div class="section" v-for="(content, index) in sections" :key="index" style="white-space: break-spaces;">
            <h2>{{ content.title }}</h2>
            <p v-if="content.body" style="text-align: justify;">&emsp;&emsp;{{ content.body }}</p>
        </div>
        
        <!-- Optional: Include images or illustrations related to the laboratory -->
        
        <div class="section" v-if="hasImages">
            <h2>赛事概览</h2>
            <div class="flex-container">
                <div class="flex-item" v-for="(image, index) in images" :key="index">
                    <img v-loading="{ minHeight: '50px', minWidth: '50px', size: '25px' }" :src="require('../assets/images/F1iS/' + image.src)" :alt="image.alt">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        sections: [
            {
                title: '什么是F1在学校？',
                body: 'F1在学校是一项全球性的STEM（科学、技术、工程、数学）竞赛，也是目前全球参与国家最多、最著名的青少年综合科技创新竞赛项目之一。自2000年源于英国，每年举办一次国际性比赛，是适合9-19岁学生参与的综合科技教育竞赛项目。目前已在50余国家的两万多所学校开展。学生需要使用CAD软件设计、制造并测试一辆缩小版的F1赛车，同时还要制定营销方案、管理团队，并进行最终答辩展示。'
            },
            {
                title: '赛事特色',
                body: '在F1在学校竞赛中，青少年学生团队使用工程软件和尖端制造技术来设计、构建微型F1赛车并一决高下。为了取得成功，团队需要仿真工具来完成赛车的设计、测试和优化工作。\n  F1在学校始终致力于提供振奋人心、富有挑战性的教育体验，借助一级方程式比赛的吸引力来提高人们对STEM的认识，并为来自世界各地的学生创造难忘的体验。',
            },
            {
                title: '赛事内容',
                body: 'F1在学校是一项跨学科综合科技创新挑战赛，内容包括科学、技术、工程、数学、设计和营销管理，团队在现实生活中模仿F1赛事，设计、测试、制造和竞赛一辆小型的F1赛车，并为此提供营销、赞助和品牌推广计划。\n  一支F1在学校队伍由3-6名学生组成，分为车队经理、市场营销经理、三维工程师、设计工程师、平面设计师、制造工程师六个角色，同学们各司其职，相互协作，共同完成。',
            },
            {
                title:'新手 Q&A',
                body: 'Q1: 我从来没有参加过F1在学校，可以报名吗？\n  A: 当然可以！F1在学校 适合不同水平的学生，即使你没有工程或竞赛经验，也可以通过团队合作和学习迅速上手。\n  \n  Q2: 我需要具备哪些技能才能参加？\n  A: 竞赛涉及多个领域，以下是常见技能，但并不要求你一开始就掌握全部：\n  ✅工程设计：学习使用Fusion 360等3D建模软件进行赛车设计。\n  ✅空气动力学：了解如何优化赛车形状以减少空气阻力。\n  ✅制造工艺：使用CNC加工、3D打印等技术制作赛车。\n  ✅团队管理：合理分工，包括项目管理、财务预算、时间安排等。\n  ✅品牌推广：制作商业计划书、设计宣传材料、寻找赞助商。\n  ✅演讲展示：准备竞赛答辩，展示团队成果。\n  \n  Q3: 我需要自己组队吗？\n  A: 是的，F1在学校 是一项团队竞赛，通常由3-6名学生组成不同角色（如工程师、经理、市场专员等）。如果你没有团队，可以向老师寻求帮助，找到合适的队友。\n  \n  Q4: 竞赛流程是怎样的？\n  A: 典型流程如下：\n  1）组建团队，明确分工。\n  2）学习软件和工具，进行赛车设计。\n  3）制造和测试，使用风洞或虚拟模拟分析赛车性能。\n  4）制作商业计划和品牌宣传，寻找赞助支持。\n  5）准备答辩材料，包括工程报告、演讲展示等。\n  6）参加比赛，进行赛车竞速、答辩展示、技术评估等环节。\n  \n  Q5: 需要投入多少时间？\n  A: 竞赛周期通常持续3-6个月，具体取决于赛程安排。一般来说，每周需要花费几小时进行赛车设计、测试和答辩准备。\n  \n  Q6: 参赛费用高吗？\n  A: 费用因地区和赛事级别不同，包括报名费、材料费、制造费和参赛差旅费等。许多团队会通过企业赞助、学校支持或众筹来降低成本。\n  \n  Q7: 我没有专业设备，怎么做赛车？\n  A: 你可以使用Fusion 360进行3D建模设计，制造阶段可以寻求学校实验室、F1在学校 官方提供的加工服务，或使用3D打印技术制作原型。\n  \n  Q8: 比赛对升学或未来职业有帮助吗？\n  A: 绝对有帮助！F1在学校 被全球多所顶级大学认可，它能培养STEM技能、团队协作、领导力和商业思维，并成为申请大学或工作的亮点。许多参与者未来进入工程、设计、汽车、商业管理等行业。\n  \n  Q9: 如何找到适合我的竞赛级别？\n  A: F1在学校 分为不同级别：\n  入门级（Entry Class）：适合新手，规则较简单。\n  发展组（Development Class）：本地赛事，获胜者可晋级。\n  全国赛（National Final）：竞争更激烈，优胜者可晋级国际赛。\n  世界锦标赛（World Finals）：全球顶级赛事，汇集各国精英团队。\n  你可以从初级赛事入手，逐步挑战更高级别的比赛！\n  \n  Q10: 参赛后有哪些成长？\n  A: 你将掌握：\n  ✅ 工程设计和制造技能\n  ✅ 团队管理和时间规划\n  ✅ 商业推广与赞助合作\n  ✅ 竞赛答辩和演讲能力\n  ✅ 真实赛车空气动力学知识\n  \n  Q11: 我该如何开始？\n  A: 你可以按照以下步骤开始：\n  1）查找当地的F1在学校竞赛信息（官网、社交媒体、学校公告）。\n  2）组建团队，找到志同道合的伙伴。\n  3）学习基本技能，如3D建模、赛车设计、市场营销。\n  4）寻求导师或指导，老师、学长或专业机构都可以提供帮助。\n  5）制定计划，安排时间和任务，有条不紊地推进。',
            },
        ],
        //Images array can be added here if available
        images: [
            // { src: "0.jpg", alt: 'F1在学校赛事赛场剪影1' },
            { src: "1.jpg", alt: 'F1在学校赛事赛场剪影2' },
            { src: "2.jpg", alt: 'F1在学校赛事赛场剪影3' },
            { src: "3.jpg", alt: 'F1在学校赛事赛场剪影4' },
            // { src: "4.jpg", alt: 'F1在学校赛事赛场剪影5' },
            { src: "5.jpg", alt: 'F1在学校赛事赛场剪影6' },
            { src: "6.jpg", alt: 'F1在学校赛事赛场剪影7' },
            { src: "7.jpg", alt: 'F1在学校赛事赛场剪影8' },
            // { src: "8.jpg", alt: 'F1在学校赛事赛场剪影9' },
            // { src: "9.jpg", alt: 'F1在学校赛事赛场剪影10' },
        ],
        hasImages: true, // Set to true if images array is defined
        };
    },
};
</script>

<style scoped>
/* Add basic styling for readability */
.F1iS {
    padding: 6vw;
    font-family: 'FangYuan';
    color: #513890;
    font-size: 1rem;
    font-weight: normal;
    letter-spacing: 0.16em;
    line-height: 2em;
}

body {
    line-height: 1.6;
    margin: 0;
    padding: 0;
}

h1 {
    text-align: center;
    margin-top: 3rem;
}

.section {
    margin-bottom: 2rem;
}

h2 {
    margin-top: 2rem;
}

ul {
    display: flex;
    list-style-type: disc;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
}

ul li{
    display: inline;
    flex: 1;
    text-align: left;
}

p {
    margin-bottom: 1rem;
}

.highlight {
    font-weight: bold;
}

.flex-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 1rem;
}

.flex-item {
    flex-basis: calc(50% - 1rem);
    margin-bottom: 1rem;
}

img {
    max-width: 100%;
    height: auto;
}

@media screen and (max-width: 768px) {
    .flex-item {
        flex-basis: 100%;
    }
}
</style>